import React, { useEffect, useState } from "react";
import {
  EuiButton,
  EuiButtonEmpty,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  useGeneratedHtmlId,
  EuiButtonIcon,
  EuiSpacer,
  EuiAvatar,
  EuiBadge,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSelect,
  EuiLink,
  EuiText,
  EuiIcon,
} from "@elastic/eui";
import OrganizationService from "../../services/organization-service";
import axios from "axios";

const OrganizationCreate = ({ closeModalProp }) => {
  const [response, setResponse] = useState("");

  const options = [
    { value: "vhdr01.astroline.com", text: "vhdr01.astroline.com" },
    { value: "voicehub.astroline.com", text: "voicehub.astroline.com" },
    { value: "flexdr02.astroline.com", text: "flexdr02.astroline.com" },
    { value: "flex8em01.008agent.ai", text: "flex8em01.008agent.ai" },
  ];

  const [nodeUrl, setNodeUrl] = useState(options[0].value);

  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [responseColor, setResponseColor] = useState("success");

  const [name, setName] = useState("L");
  const [vatNumber, setVatNumber] = useState();
  const [administratorsName, setAdministratorsName] = useState();
  const [administratorsSurname1, setAdministratorsSurname1] = useState();
  const [administratorsSurname2, setAdministratorsSurname2] = useState();
  const [administratorsPhone, setAdministratorsPhone] = useState();
  const [administratorsMail, setAdministratorsMail] = useState();
  const [companyDomain, setCompanyDomain] = useState();
  const [tenantId, setTenantId] = useState();
  const [imageUrl, setImageURL] = useState();

  const modalFormId = useGeneratedHtmlId({ prefix: "modalForm" });

  const closeModal = () => {
    setIsModalVisible(false);
    closeModalProp();
  };
  const showModal = () => setIsModalVisible(true);

  const createOrganization = async (event) => {
    event.preventDefault();
    setLoading(true);
    const token = sessionStorage.getItem("krakenT");

    const data = {
      name,
      nameLong: name,
      cif: vatNumber,
      administratorsName,
      administratorsSurname1,
      administratorsSurname2,
      administratorsPhone,
      administratorsMail,
      companyLogo: imageUrl,
      node_url: nodeUrl,
      tenantId,
    };

    OrganizationService.createOrganization({ token, data })
      .then((response) => {
        const message =
          response.data.status === "success"
            ? "Organization created succesfully"
            : "Unexpected response format";
        setResponseColor("success");
        setLoading(false);
        setResponse(message);
      })
      .catch((error) => {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Some error occurred";

        console.error(errorMessage);
        setResponseColor("danger");
        setLoading(false);
        setResponse(errorMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDomainBlur = () => {
    if (companyDomain) {
      const domain = companyDomain.replace(/^https?:\/\//, "");
      axios
        .get(`https://logo.clearbit.com/${domain}`)
        .then((response) => {
          setImageURL(response.request.responseURL);
        })
        .catch((error) => {
          setImageURL();
        })
        .finally(() => {});
    }
  };

  const formSample = (
    <EuiForm id={modalFormId} component="form" onSubmit={createOrganization}>
      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiFormRow label="Name">
            <EuiFieldText required onChange={(e) => setName(e.target.value)} />
          </EuiFormRow>
          <EuiFormRow label="VAT Number">
            <EuiFieldText
              required
              onChange={(e) => setVatNumber(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer></EuiSpacer>

      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiFormRow label="Admin Name">
            <EuiFieldText
              required
              onChange={(e) => setAdministratorsName(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow label="Admin Surname 1">
            <EuiFieldText
              required
              onChange={(e) => setAdministratorsSurname1(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow label="Admin Surname 2">
            <EuiFieldText
              required
              onChange={(e) => setAdministratorsSurname2(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer></EuiSpacer>
      <EuiFlexGroup>
        <EuiFlexItem>
          {" "}
          <EuiFormRow label="Admin Mail">
            <EuiFieldText
              required
              onChange={(e) => setAdministratorsMail(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          {" "}
          <EuiFormRow label="Admin Phone">
            <EuiFieldText
              required
              onChange={(e) => setAdministratorsPhone(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer></EuiSpacer>

      <EuiFlexGroup>
        <EuiFlexItem>
          <EuiFormRow label="Domain">
            <EuiFieldText
              required
              onBlur={handleDomainBlur}
              onChange={(e) => setCompanyDomain(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
        <EuiFlexItem>
          <EuiFormRow label="Logo">
            <EuiAvatar name={name} imageUrl={imageUrl} size="xl"></EuiAvatar>
          </EuiFormRow>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer></EuiSpacer>

      <EuiFormRow
        label={
          <>
            <EuiIcon
              type={
                "https://aadcdn.msftauthimages.net/c1c6b6c8-efe-6zmeou8nd-7fuw534xg-jiqgje2bymedfubegbs/appbranding/pzhsywlsufptpj1ssfphq9vjieb0yvg9mdrqkjf32ym/1033/bannerlogo?ts=638442076533768204"
              }
              size="s"
              title="Custom SVG icon"
            />
            &nbsp; Flex Node
          </>
        }
      >
        <EuiSelect
          id={"a"}
          options={options}
          value={nodeUrl}
          onChange={(e) => setNodeUrl(e.target.value)}
          aria-label="Use aria labels when no actual label is in use"
        />
      </EuiFormRow>
      <EuiFormRow
        label={
          <>
            <EuiIcon
              type={
                "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Microsoft_Office_Teams_%282018%E2%80%93present%29.svg/2203px-Microsoft_Office_Teams_%282018%E2%80%93present%29.svg.png"
              }
              size="s"
              title="Custom SVG icon"
            />
            &nbsp; TenantId
          </>
        }
      >
        <EuiFieldText required onChange={(e) => setTenantId(e.target.value)} />
      </EuiFormRow>
      <EuiText size="xs">
        <EuiLink
          href="https://learn.microsoft.com/en-us/partner-center/find-ids-and-domain-names#find-the-microsoft-azure-ad-tenant-id-and-primary-domain-name"
          target="_blank"
        >
          Discover how to find TenantId
        </EuiLink>
      </EuiText>
    </EuiForm>
  );

  let modal;

  if (isModalVisible) {
    modal = (
      <EuiModal
        onClose={closeModal}
        initialFocus="[name=popswitch]"
        style={{
          maxHeight: "100vh",
          marginTop: 100,
        }}
      >
        <EuiModalHeader>
          <EuiModalHeaderTitle>New Organization</EuiModalHeaderTitle>
        </EuiModalHeader>

        <EuiModalBody>
          <EuiSpacer size="m" />
          {formSample}
          <EuiSpacer size="m" />
          {response !== "" && (
            <EuiBadge color={responseColor}>{response}</EuiBadge>
          )}
        </EuiModalBody>

        <EuiModalFooter>
          <EuiButtonEmpty onClick={closeModal}>Cancel</EuiButtonEmpty>

          <EuiButton type="submit" form={modalFormId} fill isLoading={loading}>
            Save
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    );
  }

  return (
    <div>
      <EuiButton
        color="success"
        size="xs"
        display="base"
        iconType="plus"
        aria-label="Next"
        onClick={showModal}
      >
        Add new organization
      </EuiButton>
      {modal}
    </div>
  );
};

export default OrganizationCreate;
